export default {
    MONTHS: 'months',
    NAVBAR: 'navbar',
    HOME_PAGE: 'homePage',
    EVENT_PAGE: 'eventPage',
    REGISTRATION: 'registration',
    COOKIES_CONSENT: 'cookiesConsent',
    MY_COMPETITIONS: 'myCompetitions',
    CONTRACT_SIGNATURE: 'contractSignature',
    PLANNING_TV: 'planningTV',
    REVIEW_COMPETITION: 'reviewCompetition',
    FEES: 'fees',
    SIGN_UP: 'signUp',
    LOGIN: 'login',
    RESET_PASSWORD: 'resetPassword',
    ORGANIZER: 'organizer',
    MY_ACCOUNT: 'myAccount',
    LEADERBOARD_ATHLETE: 'leaderboardAthlete',
    TICKETING: 'ticketing',
    VOLUNTEERING: 'volunteering',
    SPECTATORS: 'spectators',
    PLANNING: 'planning',
    LEADERBOARD: 'leaderboard',
    ONLINE_COMPETITION_SCORES_FORM: 'onlineCompetitionScoresForm',
    STRIPE: 'stripe',
    COMMUNICATION: 'communication',
    BUZZERS_RESULTS: 'buzzersResults',
    RESERVATION_HISTORY: 'reservationHistory',
    OPEN_EVENTS_CALENDAR: 'openEventsCalendar',
    EMAIL_LOGS: 'emailLogs',
    CHECKIN: 'checkIn',
    MAINTENANCE: 'maintenance',
    USERS: 'users',
    LIVE: 'live',
    DESIGN_TRANSITION: 'designTransition',
    TOURS: 'tours',
    ADMIN: 'admin',
}
